<template>
  <div class="PagePatients">
    <v-alert
      v-if="atPatientLimit"
      type="warning"
      border="left"
      colored-border
      elevation="2"
      class="mb-4"
    >
      <div class="d-flex align-center justify-space-between flex-wrap" style="gap:8px">
        <div>
          <strong>Limite de pacientes atingido.</strong>
          Você chegou ao máximo de 5 pacientes do plano gratuito. Assine o Plano Pro para adicionar pacientes ilimitados.
        </div>
        <v-btn color="pink darken-1" dark small depressed to="/subscribe">
          <v-icon left small>mdi-star</v-icon>
          Plano Pro
        </v-btn>
      </div>
    </v-alert>

    <v-card class="mx-auto mb-4" max-width="100%">
      <v-card-title>Meus Pacientes</v-card-title>
      <v-list v-if="patients.length">
        <patient-card
          v-for="patient in patients"
          :key="patient.id"
          :patient="patient"
          @select="openDashboard"
        />
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>Nenhum paciente vinculado</v-list-item-title>
            <v-list-item-subtitle>
              Peça ao responsável que compartilhe o paciente com você pelo app.
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon @click="loadPatients">
            <v-icon>mdi-refresh</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>
    <shared-dependents @invitationAccepted="loadPatients" />
  </div>
</template>

<script>
import { PatientService } from '../../lib/spasms-control'
import { getToken, PAGES, setActualPage } from '../../utils'
import store from '../../store'
import PatientCard from '../container/PatientCard.vue'
import SharedDependents from '../container/SharedDependents.vue'

export default {
  name: 'PagePatients',
  components: { PatientCard, SharedDependents },
  data() {
    return {
      patients: []
    }
  },
  computed: {
    atPatientLimit() {
      const isPro = !!(store.state.subscription && store.state.subscription.is_pro)
      return !isPro && this.patients.length >= 5
    }
  },
  methods: {
    loadPatients() {
      const service = new PatientService(getToken())
      service.list().then(response => {
        this.patients = response.data
      }).catch(err => {
        console.error(err)
        store.setSnackBarMessageAction('Erro ao carregar pacientes')
        store.setShowSnackBarAction(true)
      })
    },
    openDashboard(patient) {
      this.$router.push({ path: `/patients/${patient.id}` })
    }
  },
  created() {
    this.loadPatients()
    setActualPage(PAGES.patients.id, this)
  }
}
</script>
